<div class="text-container">
    <span *ngIf="status === false">
        <img src="../../../assets/ontario-design-system/icons/svg/ontario-icon-alert-error.svg" alt="dangerous file">
    </span>
    <span class="text-portion" aria-label="download" [title]="displayName" [ngClass]="{'error': status === false}"
        (click)="downloadAttachment()"> {{ displayName }} </span>
</div>